// Resolution Status Constants (matching backend ResolutionStatus enum values)
export const RESOLUTION_STATUS = {
  EXACT: 0,
  NORMALIZED: 1,
  SUBSTRING: 2,
  // LLM: 3,  // Reserved for future
  UNRESOLVED: 99,
};
